import { createFeatureSelector, createSelector } from '@ngrx/store'
import * as fromSaleItemSurveyDraft from './sale-item-survey-draft.reducer'

const state = createFeatureSelector<fromSaleItemSurveyDraft.SaleItemSurveyDraftState>(
  fromSaleItemSurveyDraft.FEATURE_NAME
)

const selectState = createSelector(state, (currentState) => currentState)
const selectAll = createSelector(state, (currentState) => currentState.drafts)
const selectBySaleItemId = createSelector(
  selectAll,
  (drafts, saleItemId: number) =>
    drafts.find((draft) => draft.saleItemId === saleItemId) ?? null
)

export const saleItemSurveyDraftSelectors = {
  selectState,
  selectAll,
  selectBySaleItemId
}
